(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaos-catch-game"] && !Shopify.designMode) return;
  try {
    
/* Chaos Catch 1.0.0 | Tiny Terrors | no external libraries.
 * All timing uses seconds, not frame counts. Each section owns and cleans up
 * its listeners, observers, image requests, audio context and animation loop.
 */
(() => {
  'use strict';
  if (customElements.get('tt-chaos-catch')) return;

  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const number = (v, fallback, lo, hi) => Number.isFinite(Number(v)) ? clamp(Number(v), lo, hi) : fallback;
  const format = v => Math.floor(v).toLocaleString('en-US');
  const STORE = 'tinyterrors:chaoscatch:v1:';
  const storage = {
    get(key, fallback) { try { return localStorage.getItem(STORE + key) ?? fallback; } catch (_) { return fallback; } },
    set(key, value) { try { localStorage.setItem(STORE + key, String(value)); } catch (_) { /* Private / blocked storage: play still works. */ } }
  };
  const svg = body => `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><defs><linearGradient id="g" x2=".35" y2="1"><stop stop-color="#fff888"/><stop offset="1" stop-color="#ffae0a"/></linearGradient><linearGradient id="p" x2=".25" y2="1"><stop stop-color="#ff8ac6"/><stop offset="1" stop-color="#f31576"/></linearGradient><linearGradient id="b" x2=".6" y2="1"><stop stop-color="#636c98"/><stop offset="1" stop-color="#242940"/></linearGradient><linearGradient id="s" x2=".4" y2="1"><stop stop-color="#c2fa66"/><stop offset="1" stop-color="#63cc20"/></linearGradient></defs>${body}</svg>`;
  const ART = {
    coin: svg('<ellipse cx="48" cy="49" rx="29" ry="37" fill="#df8115" stroke="#71362a" stroke-width="4"/><ellipse cx="44" cy="46" rx="26" ry="34" fill="url(#g)" stroke="#ffd94e" stroke-width="4"/><ellipse cx="44" cy="46" rx="18" ry="26" fill="none" stroke="#e99d18" stroke-width="3"/><path d="M45 30v32m-7-28 7-4m-7 32h14" fill="none" stroke="#fff1a7" stroke-width="6" stroke-linecap="round"/><path d="M24 34q2-11 10-15" stroke="#fffadd" stroke-width="4" stroke-linecap="round" fill="none"/>'),
    star: svg('<path d="m48 7 12 26 29 4-21 21 5 30-25-14-25 14 5-30L7 37l29-4z" fill="#d88717" stroke="#6f392c" stroke-width="5" stroke-linejoin="round"/><path d="m48 10 11 25 28 4-20 18 4 27-23-12-23 12 4-27L9 39l28-4z" fill="url(#g)" stroke="#ffe984" stroke-width="3" stroke-linejoin="round"/><path d="m46 23-8 18-15 2" fill="none" stroke="#fffbd5" stroke-width="5" stroke-linecap="round"/>'),
    candy: svg('<g transform="rotate(-24 48 48)"><path d="m25 36-17-9-2 15 8 6-8 9 2 13 19-10m44-24 17-9 2 15-8 6 8 9-2 13-19-10" fill="#f32391" stroke="#782052" stroke-width="4" stroke-linejoin="round"/><rect x="24" y="24" width="48" height="48" rx="20" fill="#fff7ff" stroke="#782052" stroke-width="4"/><path d="m34 26 31 35M26 39l26 30" stroke="#ff39a0" stroke-width="10"/><rect x="24" y="24" width="48" height="48" rx="20" fill="none" stroke="#782052" stroke-width="4"/><path d="M35 31q8-4 14-2" stroke="white" stroke-width="4" fill="none" stroke-linecap="round"/></g>'),
    burger: svg('<path d="M14 62h68v8q0 14-17 14H31Q14 84 14 70z" fill="#efa225" stroke="#663124" stroke-width="4"/><path d="M14 62h69" stroke="#854124" stroke-width="13" stroke-linecap="round"/><path d="m15 52 15 2 17 11 20-11 15-2" fill="#ffde39" stroke="#c08213" stroke-width="3"/><path d="m13 49 9-5 12 5 13-5 13 6 12-5 12 5" fill="none" stroke="#4aac35" stroke-width="9" stroke-linecap="round"/><path d="M12 42C12 2 82 2 84 42z" fill="#f7ac36" stroke="#663124" stroke-width="4"/><path d="M22 31C29 13 65 10 77 29" fill="none" stroke="#ffd774" stroke-width="5" stroke-linecap="round"/><g stroke="#fff4c6" stroke-width="4" stroke-linecap="round"><path d="m33 25 2 1m13-7 3 1m13 6 2 1m-21 7 2 1"/></g>'),
    heart: svg('<path d="M48 84C36 73 8 55 8 32 8 7 39 3 48 25 57 3 88 7 88 32c0 23-28 41-40 52z" fill="url(#p)" stroke="#9d1d58" stroke-width="5" stroke-linejoin="round"/><path d="M20 29c2-9 12-11 17-5" fill="none" stroke="#ffd6ed" stroke-width="7" stroke-linecap="round"/>'),
    bomb: svg('<path d="M54 25q-1-13 12-13" fill="none" stroke="#393241" stroke-width="5"/><path d="m70 4 4 6 8-4-2 9 9 4-9 4 2 8-9-4-5 7-2-9-8-2 8-5z" fill="#ffcb34" stroke="#f18423" stroke-width="2"/><path d="m46 20 14 4-3 14-15-4z" fill="#30314c" stroke="#181d34" stroke-width="3"/><circle cx="46" cy="57" r="30" fill="url(#b)" stroke="#1e243e" stroke-width="5"/><path d="M29 43q4-10 16-11" stroke="#a6b2db" stroke-width="6" stroke-linecap="round" fill="none"/><path d="m38 56 16 15m0-15L38 71" stroke="#c5cee5" stroke-width="5" stroke-linecap="round"/>'),
    slime: svg('<path d="M14 51C13 25 32 14 48 14S82 29 82 52q11 16-2 18l-6-1q1 18-9 13l-8-10q-10 19-19 1l-6 10q-11 4-11-13-17 2-7-19z" fill="url(#s)" stroke="#398331" stroke-width="4" stroke-linejoin="round"/><path d="M26 33q5-9 15-10" fill="none" stroke="#f0ffcf" stroke-width="6" stroke-linecap="round"/><path d="m29 42 12 5m16 0 11-5" stroke="#243c2b" stroke-width="5" stroke-linecap="round"/><ellipse cx="36" cy="51" rx="4" ry="6" fill="#243c2b"/><ellipse cx="60" cy="51" rx="4" ry="6" fill="#243c2b"/><path d="M41 65q7-7 14 0" stroke="#243c2b" stroke-width="4" fill="none" stroke-linecap="round"/><circle cx="81" cy="14" r="5" fill="#9be53e" stroke="#398331" stroke-width="2"/>'),
    spike: svg('<path d="m48 4 10 20 22-8-7 23 19 10-20 10 8 22-23-8-9 20-10-20-22 8 7-23L4 48l20-10-8-22 22 8z" fill="#ffe3e8" stroke="#632838" stroke-width="4" stroke-linejoin="round"/><circle cx="48" cy="48" r="27" fill="#eb5478" stroke="#632838" stroke-width="4"/><circle cx="48" cy="48" r="8" fill="#7c263d"/><path d="m33 29 3 8m27-8-3 8m-27 29 4-7m26 7-4-7" stroke="#ffe5d9" stroke-width="4" stroke-linecap="round"/>')
  };
  const TYPES = {
    coin: {points: 10, good: true, color: '#ffd12d'},
    candy: {points: 15, good: true, color: '#ff4c9f'},
    star: {points: 20, good: true, color: '#ffe56a'},
    burger: {points: 30, good: true, color: '#fbb54a'},
    heart: {points: 0, good: true, color: '#ff66ae'},
    bomb: {points: 0, good: false, color: '#667398'},
    slime: {points: 0, good: false, color: '#9fdf55'},
    spike: {points: 0, good: false, color: '#eb5379'}
  };

  class ChaosCatch extends HTMLElement {
    static instances = new Set();
    connectedCallback() {
      if (this._booted) return;
      const configNode = this.querySelector('script[data-cc-config]');
      if (!configNode) {
        // Handles parser insertion as well as dynamically added theme sections.
        this._waiting?.disconnect();
        this._waiting = new MutationObserver(() => {
          if (this.querySelector('script[data-cc-config]')) { this._waiting.disconnect(); this.connectedCallback(); }
        });
        this._waiting.observe(this, {childList: true, subtree: true});
        return;
      }
      this._booted = true;
      this._disposed = false;
      this._abort = new AbortController();
      this._pendingImages = new Set();
      this._raf = 0;
      this._loadToken = {};
      this.state = 'loading';
      this.dataset.state = this.state;
      try { this.config = JSON.parse(configNode.textContent); }
      catch (error) { this._error('Game settings could not be read. Please check the section code.'); return; }
      this.ui = {};
      this.querySelectorAll('[data-cc]').forEach(el => { this.ui[el.dataset.cc] = el; });
      this.canvas = this.querySelector('.cc-canvas');
      this.ctx = this.canvas?.getContext('2d', {alpha: false});
      if (!this.ctx) { this._error('This browser cannot display the game. Please try another browser.'); return; }
      this.startLives = number(this.config.startingLives, 3, 1, 5);
      this.difficulty = ['relaxed','normal','fast'].includes(this.config.difficulty) ? this.config.difficulty : 'normal';
      this.pace = {relaxed: .82, normal: 1, fast: 1.18}[this.difficulty];
      this.bestKey = `best:${this.difficulty}:${this.startLives}`;
      this.best = number(storage.get(this.bestKey, '0'), 0, 0, 999999999);
      this.soundOn = this.config.allowSound !== false && storage.get('sound', '0') === '1';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.characters = Array.isArray(this.config.characters) ? this.config.characters.slice(0, 12) : [];
      if (!this.characters.length) { this._error('Add at least one Character block in this game’s theme settings.'); return; }
      const remembered = storage.get('character', this.config.defaultCharacter || 'darla');
      this.selected = Math.max(0, this.characters.findIndex(c => c.key === remembered));
      this.icons = {}; this.iconURLs = {}; this.backgrounds = {};
      this.keys = new Set(); this.heldDirection = 0; this.pointerId = null;
      this.W = 1; this.H = 1; this.playerX = .5; this.targetX = .5;
      this.score = 0; this.lives = this.startLives; this.elapsed = 0; this.level = 1;
      this.streak = 0; this.multiplier = 1; this.items = []; this.particles = []; this.popups = [];
      this.lean = 0; this.bounce = 0; this.shield = 0; this.slow = 0; this.toastTime = 0;
      ChaosCatch.instances.add(this);
      this._buildRoster(); this._soundUI(); this._bind(); this._measure();
      this._resize = new ResizeObserver(() => this._measure()); this._resize.observe(this.canvas);
      if ('IntersectionObserver' in window) {
        this._intersection = new IntersectionObserver(entries => {
          if (entries[0].intersectionRatio < .08 && this._isActive()) this.pause('You scrolled away. Your game is safe here.');
        }, {threshold: [0, .08]});
        this._intersection.observe(this.canvas);
      }
      this._loadAssets(this._loadToken);
    }
    disconnectedCallback() { this.destroy(); }
    destroy() {
      this._waiting?.disconnect();
      if (!this._booted) return;
      if (this.bestKey && Number.isFinite(this.best)) storage.set(this.bestKey, this.best);
      this._disposed = true; this._booted = false; this._loadToken = null;
      cancelAnimationFrame(this._raf); this._raf = 0;
      this._abort?.abort(); this._resize?.disconnect(); this._intersection?.disconnect();
      this._pendingImages?.forEach(cancel => cancel()); this._pendingImages?.clear();
      if (this.audio) { this.audio.close().catch(() => {}); this.audio = null; }
      ChaosCatch.instances.delete(this);
    }
    _error(message) {
      const alert = this.querySelector('[data-cc="alert"]');
      if (alert) { alert.hidden = false; alert.textContent = message; }
      const label = this.querySelector('[data-cc="main-label"]');
      if (label) label.textContent = 'SETUP NEEDED';
    }
    _on(target, name, fn, options = {}) { target.addEventListener(name, fn, {...options, signal: this._abort.signal}); }
    _isActive() { return this.state === 'playing' || this.state === 'countdown'; }
    _setState(state) {
      this.state = state; this.dataset.state = state;
      const locked = this._isActive() || state === 'paused';
      this.querySelectorAll('.cc-character').forEach(b => { b.disabled = locked; });
      this.querySelector('[data-action="pause"]').disabled = !(this._isActive() || state === 'paused');
      this.ui.session.textContent = {loading:'GETTING READY',ready:'READY FOR CHAOS',countdown:'GET READY',playing:'CATCH & DODGE',paused:'ON A TINY BREAK',over:'NICE CHAOS!'}[state];
      this.ui['main-label'].textContent = state === 'loading' ? 'LOADING…' : state === 'ready' ? 'START GAME' : state === 'over' ? 'PLAY AGAIN' : 'RESTART GAME';
      this.querySelector('[data-action="main"]').disabled = state === 'loading';
      this.querySelector('[data-action="pause"]').setAttribute('aria-label', state === 'paused' ? 'Resume game' : 'Pause game');
      this.ui['pause-label'].textContent = state === 'paused' ? 'Resume' : 'Pause';
      this.ui['pause-path'].setAttribute('d', state === 'paused' ? 'M8 5v14l11-7z' : 'M8 5v14M16 5v14');
      this.ui['selected-name'].textContent = locked ? 'Locked this round' : this.characters[this.selected].name;
    }
    _buildRoster() {
      const editorAttributes = [...this.ui.roster.children].map(node => [...node.attributes].filter(a => a.name.startsWith('data-shopify-')).map(a => [a.name, a.value]));
      this.ui.roster.replaceChildren();
      this.characters.forEach((c, index) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'cc-character';
        (editorAttributes[index] || []).forEach(([name, value]) => button.setAttribute(name, value));
        button.dataset.index = String(index); button.setAttribute('aria-pressed', String(index === this.selected));
        button.setAttribute('aria-label', 'Play as ' + c.name);
        const img = document.createElement('img'); img.alt = ''; img.width = 49; img.height = 67; img.decoding = 'async';
        if (c.url) img.src = c.url;
        const name = document.createElement('span'); name.textContent = c.name;
        button.append(img, name); this.ui.roster.append(button);
        this._on(img, 'error', () => { img.style.visibility = 'hidden'; });
      });
      this.ui['selected-name'].textContent = this.characters[this.selected].name;
    }
    selectCharacter(index, force = false) {
      if (!force && this.state !== 'ready' && this.state !== 'over') return;
      if (!this.characters[index]) return;
      this.selected = index; storage.set('character', this.characters[index].key);
      this.ui.roster.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
      this.ui['selected-name'].textContent = this.characters[index].name;
      this._announce(this.characters[index].name + ' selected.'); this.draw();
    }
    _loadImage(url) {
      return new Promise(resolve => {
        if (!url) { resolve(null); return; }
        const image = new Image(); image.decoding = 'async'; let done = false;
        const finish = value => {
          if (done) return; done = true; clearTimeout(timeout);
          image.onload = null; image.onerror = null; this._pendingImages.delete(cancel); resolve(value);
        };
        const cancel = () => { finish(null); image.src = ''; };
        const timeout = setTimeout(() => finish(null), 8000);
        this._pendingImages.add(cancel);
        image.onload = () => finish(image); image.onerror = () => finish(null); image.src = url;
      });
    }
    async _loadAssets(token) {
      const requests = [];
      for (const [key, source] of Object.entries(ART)) {
        this.iconURLs[key] = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source);
        requests.push((async () => {
          const custom = this.config.items?.[key];
          const customImage = custom ? await this._loadImage(custom) : null;
          if (customImage) { this.icons[key] = customImage; this.iconURLs[key] = custom; }
          else this.icons[key] = await this._loadImage(this.iconURLs[key]);
        })());
      }
      this.characters.forEach(c => requests.push(this._loadImage(c.url).then(img => { c.image = img; })));
      for (const type of ['desktop', 'mobile']) {
        const url = this.config.backgrounds?.[type];
        if (url) requests.push(this._loadImage(url).then(img => { this.backgrounds[type] = img; }));
      }
      await Promise.all(requests);
      if (this._disposed || token !== this._loadToken) return;
      const missing = this.characters.filter(c => !c.image).map(c => c.name);
      if (missing.length) {
        this.ui.alert.hidden = false;
        this.ui.alert.textContent = 'Character images not loaded: ' + missing.join(', ') + '. Upload the supplied cc-*.webp files to Shopify Content → Files, or select an image in each Character block. A letter marker is used until then.';
      }
      for (const [slot, types] of [['good-icons',['coin','star','candy','heart','burger']],['bad-icons',['bomb','slime','spike']]]) {
        this.ui[slot].replaceChildren(...types.map(t => { const img = document.createElement('img'); img.src = this.iconURLs[t]; img.alt = ''; img.width = 30; img.height = 30; return img; }));
      }
      this._paintScenery(); this._updateHUD(true); this._setState('ready'); this.draw();
    }
    _bind() {
      this._on(this, 'click', e => {
        const character = e.target.closest('.cc-character');
        if (character && this.contains(character)) this.selectCharacter(Number(character.dataset.index));
        const button = e.target.closest('[data-action]');
        if (!button || !this.contains(button) || button.disabled) return;
        switch (button.dataset.action) {
          case 'main': if (this.state === 'ready' || this.state === 'over') this.start(); else this._confirmRestart(); break;
          case 'pause': this.state === 'paused' ? this.resume() : this.pause(); break;
          case 'sound': this._toggleSound(); break;
          case 'help': this._help(); break;
          case 'dialog-primary': this._dialogAction(true); break;
          case 'dialog-secondary': this._dialogAction(false); break;
        }
      });
      this._on(this.canvas, 'pointerdown', e => {
        if (!this._isActive()) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault(); this.canvas.focus({preventScroll: true});
        this.pointerId = e.pointerId; this.canvas.setPointerCapture(e.pointerId); this._pointerTarget(e);
      });
      this._on(this.canvas, 'pointermove', e => {
        if (!this._isActive()) return;
        if (e.pointerType === 'mouse' || e.pointerId === this.pointerId) this._pointerTarget(e);
      });
      this._on(this.canvas, 'lostpointercapture', () => { this.pointerId = null; });
      this.querySelectorAll('[data-direction]').forEach(button => {
        this._on(button, 'pointerdown', e => {
          if (!this._isActive()) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          e.preventDefault(); button.setPointerCapture(e.pointerId);
          this.heldDirection = Number(button.dataset.direction); this.targetX = this.playerX;
          button.classList.add('is-held'); this.canvas.focus({preventScroll: true});
        });
        this._on(button, 'lostpointercapture', () => this._clearInput());
      });
      this._on(window, 'pointerup', () => this._clearInput());
      this._on(window, 'pointercancel', () => this._clearInput());
      this._on(this, 'keydown', e => {
        const overlayOpen = !this.ui.overlay.hidden;
        if (overlayOpen && e.key === 'Tab') {
          const focusable = [...this.ui.overlay.querySelectorAll('button:not([hidden]):not(:disabled)')];
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (!this.ui.overlay.contains(document.activeElement)) { e.preventDefault(); first?.focus(); }
          else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
          return;
        }
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
        if (e.key === 'Escape') {
          if (this._isActive()) { e.preventDefault(); this.pause(); }
          else if (this.state === 'paused') { e.preventDefault(); this.resume(); }
          else if (this.dialogMode === 'help') { e.preventDefault(); this._dialogAction(true); }
          return;
        }
        if (e.code === 'Space' && e.target === this.canvas) {
          e.preventDefault(); if (e.repeat) return;
          if (this._isActive()) this.pause(); else if (this.state === 'paused') this.resume();
          return;
        }
        if (['ArrowLeft','ArrowRight','KeyA','KeyD'].includes(e.code) && this._isActive()) {
          e.preventDefault(); this.keys.add(e.code); this.targetX = this.playerX;
        }
      });
      this._on(window, 'keyup', e => {
        this.keys.delete(e.code);
        if (!this.keys.size && !this.pointerId) this.targetX = this.playerX;
      });
      this._on(window, 'blur', () => { this._clearInput(); if (this._isActive()) this.pause('You left the game window. Ready when you are.'); });
      this._on(document, 'visibilitychange', () => { if (document.hidden && this._isActive()) this.pause('Your game paused while this tab was hidden.'); });
      this._on(document, 'shopify:block:select', e => {
        const index = this.characters.findIndex(c => c.blockId === e.detail?.blockId);
        if (index < 0) return;
        if (this._isActive()) this.pause();
        this.selectCharacter(index, true);
      });
      this._on(document, 'shopify:section:unload', e => { if (e.target === this || e.target.contains(this)) this.destroy(); });
    }
    _pointerTarget(e) {
      const r = this.canvas.getBoundingClientRect();
      this.targetX = clamp((e.clientX - r.left) / r.width * this.W, this.margin, this.W - this.margin);
    }
    _clearInput() {
      this.keys?.clear(); this.heldDirection = 0; this.pointerId = null;
      this.querySelectorAll('.is-held').forEach(b => b.classList.remove('is-held'));
    }
    _measure() {
      if (!this.ctx || this._disposed) return;
      const rect = this.canvas.getBoundingClientRect();
      const w = Math.max(1, Math.round(rect.width)), h = Math.max(1, Math.round(rect.height));
      if (w === this.W && h === this.H) return;
      const oldW = this.W, oldH = this.H;
      if (oldW > 1 && this._isActive() && (Math.abs(w-oldW) > 30 || Math.abs(h-oldH) > 30)) this.pause('Screen size changed. Resume when you’re ready.');
      this.W = w; this.H = h; this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(w * this.dpr); this.canvas.height = Math.round(h * this.dpr);
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
      this.playerH = Math.min(h*.35, clamp(w*.15, 110, 160));
      this.playerW = clamp(w*.075, 51, 81); // Same gameplay catch box for every character.
      this.margin = Math.max(this.playerW*.72, this.playerH*.43);
      this.ground = h - 18;
      this.itemSize = clamp(w*.05, 30, 52);
      this.playerX = clamp((this.playerX / oldW) * w, this.margin, w-this.margin); this.targetX = this.playerX;
      this.items.forEach(item => { item.x *= w / oldW; item.y *= h / oldH; item.vy *= h / oldH; item.size = this.itemSize * item.scale; });
      this.particles = []; this.popups = []; this._paintScenery(); this.draw();
    }
    start() {
      if (this.state === 'loading') return;
      ChaosCatch.instances.forEach(instance => { if (instance !== this && instance._isActive()) instance.pause('Another Chaos Catch game was started.'); });
      this._ensureAudio(); this._clearInput(); this.roundBestAtStart = this.best;
      this.score = 0; this.lives = this.startLives; this.elapsed = 0; this.level = 1;
      this.streak = 0; this.multiplier = 1; this.items = []; this.particles = []; this.popups = [];
      this.spawnIn = .3; this.heartIn = 12; this.shield = 0; this.slow = 0; this.lean = 0; this.bounce = 0;
      this.playerX = this.W / 2; this.targetX = this.playerX;
      this.toastTime = 0; this.ui.toast.hidden = true; this.ui.overlay.hidden = true; this.dialogMode = '';
      this._updateHUD(true); this._countIn();
    }
    _countIn() {
      this.count = 3; this.lastCount = 3; this.ui['count-number'].textContent = '3';
      this.ui.countdown.hidden = false; this.ui.overlay.hidden = true; this.dialogMode = '';
      this._setState('countdown'); this.canvas.focus({preventScroll: true});
      this._announce('Get ready. Catch goodies and avoid hazards.'); this._run();
    }
    _run() {
      cancelAnimationFrame(this._raf); this._lastTime = 0;
      this._raf = requestAnimationFrame(t => this._frame(t));
    }
    _frame(timestamp) {
      this._raf = 0;
      if (this._disposed || !this._isActive()) return;
      const dt = this._lastTime ? Math.min((timestamp - this._lastTime) / 1000, .1) : 0;
      this._lastTime = timestamp;
      if (this.state === 'countdown') {
        this.count -= dt;
        const current = Math.max(1, Math.ceil(this.count));
        if (current !== this.lastCount) { this.lastCount = current; this.ui['count-number'].textContent = String(current); this._tone('tick'); }
        if (this.count <= 0) { this.ui.countdown.hidden = true; this._setState('playing'); this._toast('Catch goodies. Dodge trouble!', 2); this._tone('start'); }
      } else {
        // Small physics steps keep collision detection reliable at low frame rates.
        let remaining = dt;
        while (remaining > 0 && this.state === 'playing') { const step = Math.min(remaining, 1/120); this._update(step); remaining -= step; }
      }
      this.draw(); this._updateHUD();
      if (this._isActive()) this._raf = requestAnimationFrame(t => this._frame(t));
    }
    _update(dt) {
      this.elapsed += dt;
      const nextLevel = Math.min(10, 1 + Math.floor(this.elapsed / 18));
      if (nextLevel !== this.level) { this.level = nextLevel; this._toast(`LEVEL ${this.level} — a little more chaos!`, 2.4); this._tone('level'); }
      this.shield = Math.max(0, this.shield-dt); this.slow = Math.max(0, this.slow-dt); this.bounce = Math.max(0, this.bounce-dt*3);
      if (this.toastTime > 0) { this.toastTime -= dt; if (this.toastTime <= 0) this.ui.toast.hidden = true; }
      const oldX = this.playerX;
      const left = this.keys.has('ArrowLeft') || this.keys.has('KeyA');
      const right = this.keys.has('ArrowRight') || this.keys.has('KeyD');
      const direction = this.heldDirection || (Number(right) - Number(left));
      const speed = this.W * .9 * (this.slow > 0 ? .48 : 1);
      if (direction) { this.playerX += direction * speed * dt; this.targetX = this.playerX; }
      else this.playerX += clamp(this.targetX - this.playerX, -speed*dt, speed*dt);
      this.playerX = clamp(this.playerX, this.margin, this.W-this.margin);
      const desiredLean = this.reducedMotion ? 0 : clamp((this.playerX-oldX)/Math.max(dt,.001)/this.W, -.9, .9)*.11;
      this.lean += (desiredLean-this.lean) * Math.min(1, dt*14);
      this.spawnIn -= dt; this.heartIn -= dt;
      if (this.spawnIn <= 0 && this.items.length < 18) {
        this._spawn(); this.spawnIn = Math.max(.32, .95-(this.level-1)*.062)/this.pace * (.8+Math.random()*.4);
      }
      if (this.heartIn <= 0 && this.items.length < 18) { this._spawn('heart'); this.heartIn = 15+Math.random()*8; }
      const top = this.ground-this.playerH*.83;
      for (let i=this.items.length-1; i>=0; i--) {
        const item = this.items[i]; item.y += item.vy*dt; item.rotation += item.spin*dt;
        const radius = item.size*.36;
        const hit = Math.abs(item.x-this.playerX) < this.playerW*.5+radius && item.y+radius > top && item.y-radius < this.ground-3;
        if (hit) {
          this.items.splice(i,1); this._catch(item);
          if (this.state !== 'playing') return;
        } else if (item.y-radius > this.H+8) {
          this.items.splice(i,1);
          if (TYPES[item.type].good && item.type !== 'heart') { this.streak=0; this.multiplier=1; }
        }
      }
      for (let i=this.particles.length-1; i>=0; i--) {
        const p=this.particles[i]; p.life-=dt; p.x+=p.vx*dt; p.y+=p.vy*dt; p.vy+=155*dt;
        if(p.life<=0) this.particles.splice(i,1);
      }
      for (let i=this.popups.length-1; i>=0; i--) { const p=this.popups[i]; p.life-=dt; p.y-=30*dt; if(p.life<=0) this.popups.splice(i,1); }
    }
    _spawn(forced) {
      let type = forced;
      if (!type) {
        const hazardChance = Math.min(.31,.18+(this.level-1)*.015);
        if (Math.random()<hazardChance) { const hazards=this.level<3?['bomb','slime']:['bomb','slime','spike']; type=hazards[Math.floor(Math.random()*hazards.length)]; }
        else { const goods=['coin','coin','candy','candy','star','burger']; type=goods[Math.floor(Math.random()*goods.length)]; }
      }
      const scale = type==='burger' ? 1.08 : type==='heart' ? .88 : 1;
      const size=this.itemSize*scale;
      const travel = this.ground-this.playerH*.83;
      const time = Math.max(1.45,3.7-(this.level-1)*.21)/this.pace;
      this.items.push({type,x:size/2+8+Math.random()*(this.W-size-16),y:-size,
        size,scale,vy:(travel+size)/time*(.94+Math.random()*.12),rotation:0,spin:this.reducedMotion?0:(Math.random()-.5)*.45});
    }
    _catch(item) {
      const kind=TYPES[item.type]; this.bounce=.3;
      if (!kind.good) {
        if (this.shield>0) return;
        this.lives=Math.max(0,this.lives-1); this.streak=0; this.multiplier=1; this.shield=1.2;
        if (item.type==='slime') this.slow=2;
        this._pop(item.type==='slime'?'SLOWED!':'−1 LIFE',this.playerX,this.ground-this.playerH,'#912853');
        this._burst(item.x,item.y,kind.color); this._tone('bad');
        this._announce(`${this.lives} ${this.lives===1?'life':'lives'} left.`);
        if(this.lives<=0) this._end();
        return;
      }
      if(item.type==='heart') {
        if(this.lives<5) { this.lives++; this._pop('+1 LIFE',item.x,item.y,'#af216b'); this._announce('Extra life. '+this.lives+' lives.'); }
        else { this.score+=25; this._pop('+25',item.x,item.y,'#af216b'); }
        this._tone('heart');
      } else {
        const oldMultiplier=this.multiplier;
        this.streak++;
        this.multiplier=Math.min(4,1+Math.floor(this.streak/5));
        const gain=kind.points*this.multiplier; this.score+=gain;
        this._pop('+'+gain+(this.multiplier>1?' ×'+this.multiplier:''),item.x,item.y,'#353060');
        if(this.multiplier>oldMultiplier) { this._toast(this.multiplier===4?'CHAOS COMBO ×4!':`NICE STREAK! ×${this.multiplier} points`,1.7); this._tone('level'); }
        else this._tone('good');
      }
      this._burst(item.x,item.y,kind.color);
      if(this.score>this.best) { this.best=this.score; /* Persist at end/pause, not on every animation frame. */ }
    }
    pause(message='Take a breath. The goodies can wait.') {
      if(!this._isActive()) return;
      cancelAnimationFrame(this._raf); this._raf=0; this._clearInput(); this.targetX=this.playerX;
      this.ui.countdown.hidden=true; this.ui.toast.hidden=true; this._setState('paused');
      storage.set(this.bestKey,this.best); this._showDialog('pause','A tiny break',message,'RESUME GAME','Choose another Terror','Ⅱ'); this.draw();
    }
    resume() { if(this.state!=='paused') return; this._ensureAudio(); this._clearInput(); this._countIn(); }
    _confirmRestart() {
      if(this._isActive()) this.pause();
      this._showDialog('restart','Start fresh?','Your current round will end. Your best score is kept.','YES, RESTART','Keep playing','↻');
    }
    _help() {
      if(this._isActive()) this.pause();
      this.helpFrom=this.state;
      this._showDialog('help','A little how-to','',this.state==='paused'?'BACK TO GAME':'GOT IT','', '?');
      // Static help content only; no merchant strings are inserted as HTML.
      this.ui['dialog-copy'].innerHTML='<p><b>Move:</b> mouse, ← → / A D, drag, or hold the arrow buttons.</p><p><b>Catch:</b> coin +10, candy +15, star +20, burger +30. Hearts add a life (maximum 5; then +25 points).</p><p><b>Dodge:</b> bombs, spikes and slime cost one life. Slime also slows you for 2 seconds.</p><p><b>Combos:</b> 5 catches = ×2, 10 = ×3, 15 = ×4. Missing a goodie resets the combo, not your lives.</p><p>Every 18 seconds the game speeds up, up to level 10. Survive as long as you can!</p>';
    }
    _showDialog(mode,title,copy,primary,secondary,mark) {
      this.dialogMode=mode; this.ui.overlay.hidden=false;
      this.ui['dialog-title'].textContent=title; this.ui['dialog-copy'].textContent=copy;
      this.ui['dialog-mark'].textContent=mark;
      this.ui.result.hidden=mode!=='over';
      this.querySelector('.cc-dialog').setAttribute('aria-label',title);
      const p=this.querySelector('[data-action="dialog-primary"]'),s=this.querySelector('[data-action="dialog-secondary"]');
      p.textContent=primary; s.textContent=secondary; s.hidden=!secondary;
      p.focus({preventScroll:true}); this._announce(title+'. '+copy);
    }
    _dialogAction(primary) {
      const mode=this.dialogMode;
      if(mode==='over') { primary?this.start():this._ready(); return; }
      if(mode==='restart') { primary?this.start():this.resume(); return; }
      if(mode==='pause') { primary?this.resume():this._ready(); return; }
      if(mode==='help') {
        this.ui.overlay.hidden=true; this.dialogMode='';
        if(this.helpFrom==='paused') this.resume();
        else if(this.helpFrom==='over') this._gameOverDialog();
        else this.querySelector('[data-action="help"]').focus({preventScroll:true});
      }
    }
    _ready() {
      cancelAnimationFrame(this._raf); this._raf=0; this._clearInput(); storage.set(this.bestKey,this.best);
      this.score=0; this.lives=this.startLives; this.elapsed=0; this.level=1; this.multiplier=1; this.streak=0;
      this.items=[]; this.particles=[]; this.popups=[]; this.lean=0; this.bounce=0; this.shield=0; this.slow=0;
      this.ui.overlay.hidden=true; this.ui.countdown.hidden=true; this.ui.toast.hidden=true; this.dialogMode='';
      this.playerX=this.W/2; this.targetX=this.playerX; this._setState('ready'); this._updateHUD(true); this.draw();
      this.ui.roster.querySelectorAll('button')[this.selected]?.focus({preventScroll:true});
    }
    _end() {
      cancelAnimationFrame(this._raf); this._raf=0; this._clearInput(); this.ui.toast.hidden=true;
      this._setState('over'); storage.set(this.bestKey,this.best); this._updateHUD(true); this._gameOverDialog(); this.draw();
    }
    _gameOverDialog() {
      this.ui['result-score'].textContent=format(this.score); this.ui['result-best'].textContent=format(this.best);
      const record=this.score>0 && this.score>(this.roundBestAtStart || 0);
      this._showDialog('over',record?'Big tiny record!':'That was some chaos!',`${this.characters[this.selected].name} reached level ${this.level} in ${Math.floor(this.elapsed)} seconds. Ready for another go?`,'PLAY AGAIN','Choose another Terror',record?'★':'✦');
    }
    _updateHUD(force=false) {
      const values={score:format(this.score),best:format(this.best),level:String(this.level),multiplier:'×'+this.multiplier};
      for(const [key,value] of Object.entries(values)) if(force||this.ui[key].textContent!==value) this.ui[key].textContent=value;
      this.ui.multiplier.setAttribute('aria-label','Score multiplier '+this.multiplier);
      const progress=this.level===10?100:Math.floor((this.elapsed%18)/18*100);
      if(force||this._lastProgress!==progress) { this._lastProgress=progress; this.ui['progress-fill'].style.width=progress+'%'; this.ui.progress.setAttribute('aria-valuenow',String(progress)); this.ui.progress.setAttribute('aria-label',this.level===10?'Maximum level reached':'Progress to next level'); }
      if(force||this._lastLives!==this.lives) {
        this._lastLives=this.lives; this.ui.hearts.replaceChildren();
        for(let i=0;i<this.lives;i++) { const image=document.createElement('img'); image.src=this.iconURLs.heart||''; image.alt=''; image.width=24; image.height=24; this.ui.hearts.append(image); }
        if(!this.lives) this.ui.hearts.textContent='0';
        this.ui['lives-text'].textContent=this.lives+' lives remaining';
      }
    }
    _toast(text,time=2) {this.toastTime=time;this.ui.toast.textContent=text;this.ui.toast.hidden=false;}
    _announce(text) {this.ui.live.textContent=text;}
    _pop(text,x,y,color) {if(this.popups.length<12)this.popups.push({text,x,y,life:.85,color});}
    _burst(x,y,color) {
      if(this.reducedMotion)return;
      for(let i=0;i<8&&this.particles.length<72;i++){const a=Math.random()*Math.PI*2,sp=30+Math.random()*90;this.particles.push({x,y,vx:Math.cos(a)*sp,vy:Math.sin(a)*sp-35,life:.3+Math.random()*.35,color,size:2+Math.random()*3});}
    }
    _toggleSound() {
      if(this.config.allowSound===false)return;
      this.soundOn=!this.soundOn; storage.set('sound',this.soundOn?'1':'0'); this._soundUI();
      if(this.soundOn){this._ensureAudio();this._tone('good');}
    }
    _soundUI() {
      const button=this.querySelector('[data-action="sound"]'); button.hidden=this.config.allowSound===false;
      button.setAttribute('aria-pressed',String(this.soundOn));button.setAttribute('aria-label',this.soundOn?'Turn sound off':'Turn sound on');
      this.ui['sound-label'].textContent=this.soundOn?'Sound on':'Sound off';
      this.ui['sound-lines'].setAttribute('d',this.soundOn?'M16 8q4 4 0 8M19 5q7 7 0 14':'m16 9 6 6m0-6-6 6');
    }
    _ensureAudio() {
      if(!this.soundOn)return;
      try { const Audio=window.AudioContext||window.webkitAudioContext;if(!Audio)return;if(!this.audio)this.audio=new Audio();if(this.audio.state==='suspended')this.audio.resume().catch(()=>{}); }catch(_){/* Audio is optional. */}
    }
    _tone(type) {
      if(!this.soundOn||!this.audio||this.audio.state!=='running')return;
      if(this._lastTone&&this.audio.currentTime-this._lastTone<.035)return;this._lastTone=this.audio.currentTime;
      const notes={good:[660,880],bad:[170,85],heart:[660,1100],level:[780,1240],start:[440,880],tick:[420,520]}[type]||[660,880];
      try{const osc=this.audio.createOscillator(),gain=this.audio.createGain(),t=this.audio.currentTime;osc.type='sine';osc.frequency.setValueAtTime(notes[0],t);osc.frequency.exponentialRampToValueAtTime(notes[1],t+.12);gain.gain.setValueAtTime(.0001,t);gain.gain.exponentialRampToValueAtTime(.055,t+.015);gain.gain.exponentialRampToValueAtTime(.0001,t+.18);osc.connect(gain);gain.connect(this.audio.destination);osc.start(t);osc.stop(t+.19);osc.onended=()=>{osc.disconnect();gain.disconnect();};}catch(_){}
    }
    _paintScenery() {
      const w=this.W,h=this.H;
      if(!w||!h)return;
      this.scenery=document.createElement('canvas');this.scenery.width=Math.round(w*this.dpr);this.scenery.height=Math.round(h*this.dpr);
      const c=this.scenery.getContext('2d');c.scale(this.dpr,this.dpr);
      const photo=(w<=600?this.backgrounds.mobile:null)||this.backgrounds.desktop||this.backgrounds.mobile;
      if(photo){const scale=Math.max(w/photo.width,h/photo.height),dw=photo.width*scale,dh=photo.height*scale;c.drawImage(photo,(w-dw)/2,h-dh,dw,dh);return;}
      const sky=c.createLinearGradient(0,0,0,h);sky.addColorStop(0,'#75ccf5');sky.addColorStop(.58,'#c4edfa');sky.addColorStop(1,'#fff2bd');c.fillStyle=sky;c.fillRect(0,0,w,h);
      const ellipse=(x,y,rx,ry,col)=>{c.fillStyle=col;c.beginPath();c.ellipse(x,y,rx,ry,0,0,Math.PI*2);c.fill();};
      const cloud=(x,y,s)=>{c.save();c.translate(x,y);c.scale(s,s);c.fillStyle='#ffffffbc';c.beginPath();c.moveTo(-66,19);c.bezierCurveTo(-84,0,-60,-23,-36,-13);c.bezierCurveTo(-25,-49,18,-49,32,-16);c.bezierCurveTo(65,-29,89,12,57,25);c.lineTo(-61,25);c.fill();c.restore();};
      cloud(w*.08,h*.21,.9);cloud(w*.88,h*.13,1.15);cloud(w*.47,h*.04,.64);cloud(w*.62,h*.41,.83);cloud(w*.17,h*.61,.64);
      // Hazy, distant hills keep the central falling-items lane uncluttered.
      c.fillStyle='#9fded5';c.beginPath();c.moveTo(0,h);
      for(let i=0;i<8;i++){const x=i*w/7;c.quadraticCurveTo(x-w/14,h*.52+(i%3)*20,x,h*.77);}
      c.lineTo(w,h);c.closePath();c.fill();
      c.fillStyle='#a5dcae';c.beginPath();c.moveTo(0,h);c.bezierCurveTo(w*.05,h*.59,w*.22,h*.91,w*.4,h*.82);c.bezierCurveTo(w*.64,h*.69,w*.8,h*.61,w,h*.8);c.lineTo(w,h);c.fill();
      const island=(x,y,s,water=true)=>{
        c.save();c.translate(x,y);c.scale(s,s);
        // Water is painted behind the rock, then the grassy top.
        if(water){const waterfall=c.createLinearGradient(0,0,0,130);waterfall.addColorStop(0,'#a4efffd9');waterfall.addColorStop(1,'#b7e6f000');c.fillStyle=waterfall;c.fillRect(13,18,17,119);c.fillStyle='#e7fbff9e';c.fillRect(16,20,3,87);}
        c.fillStyle='#b2a8c8';c.beginPath();c.moveTo(-68,0);c.lineTo(-58,42);c.lineTo(-27,67);c.lineTo(-8,56);c.lineTo(11,76);c.lineTo(35,42);c.lineTo(59,31);c.lineTo(70,0);c.closePath();c.fill();
        c.fillStyle='#d5b6cb';c.beginPath();c.moveTo(-48,1);c.lineTo(-34,50);c.lineTo(-17,62);c.lineTo(-20,0);c.fill();c.fillStyle='#8f9ab9';c.beginPath();c.moveTo(37,0);c.lineTo(27,42);c.lineTo(12,66);c.lineTo(18,0);c.fill();
        ellipse(-3,0,71,18,'#75bf73');ellipse(-5,-5,70,14,'#b4e478');
        c.fillStyle='#80cc5b';c.beginPath();c.moveTo(-72,-4);c.quadraticCurveTo(-59,10,-55,22);c.quadraticCurveTo(-44,25,-40,4);c.quadraticCurveTo(-31,29,-21,4);c.quadraticCurveTo(-8,17,-2,1);c.quadraticCurveTo(8,27,18,4);c.quadraticCurveTo(34,17,38,1);c.quadraticCurveTo(59,25,69,-4);c.closePath();c.fill();
        ellipse(-32,-13,18,22,'#7dc27a');ellipse(-18,-22,19,22,'#79c680');ellipse(-6,-10,17,16,'#94d778');
        c.fillStyle='#ccb3c5';c.beginPath();c.moveTo(22,-9);c.lineTo(24,-29);c.quadraticCurveTo(34,-39,44,-28);c.lineTo(49,-8);c.fill();ellipse(36,-9,13,4,'#a2cd6f');
        c.restore();
      };
      island(w*.115,h*.245,clamp(w/1100,.48,1)*.97);
      island(w*.89,h*.40,clamp(w/1100,.48,1)*1.15);
      island(w*.68,h*.115,clamp(w/1200,.33,.8)*.7);
      const bushes=(x,y,s)=>{ellipse(x-20*s,y,23*s,21*s,'#66b590');ellipse(x+3*s,y-15*s,29*s,28*s,'#7ec57c');ellipse(x+28*s,y+2*s,29*s,23*s,'#91d36e');ellipse(x+6*s,y+8*s,32*s,16*s,'#b3e26d');};
      for(let i=0;i<9;i++)bushes(i*w/8,h-43-(i%3)*9,.82+(i%2)*.15);
      // A small friendly stone statue echoes the fantasy-world mockup.
      if(w>520){
        c.save();c.translate(w*.85,h-55);c.rotate(-.07);c.fillStyle='#8caeb6';c.beginPath();c.roundRect(-28,-53,57,58,15);c.fill();c.fillStyle='#97bac0';c.beginPath();c.roundRect(-21,-92,14,50,7);c.roundRect(10,-92,13,50,7);c.fill();ellipse(-11,-30,5,7,'#647e95');ellipse(13,-30,5,7,'#647e95');c.strokeStyle='#698599';c.lineWidth=4;c.beginPath();c.arc(1,-20,10,0,Math.PI);c.stroke();c.restore();
      }
      // Foreground plateau, kept narrow so falling items remain readable.
      c.fillStyle='#71bb63';c.beginPath();c.moveTo(0,h-25);c.quadraticCurveTo(w*.45,h-48,w,h-25);c.lineTo(w,h);c.lineTo(0,h);c.fill();
      c.fillStyle='#b4e85b';c.beginPath();c.moveTo(0,h-31);c.quadraticCurveTo(w*.48,h-39,w,h-30);c.lineTo(w,h-19);c.quadraticCurveTo(w*.55,h-25,0,h-17);c.closePath();c.fill();
      c.fillStyle='#c8ef79';c.fillRect(0,h-31,w,3);
      for(let i=0;i<23;i++){const x=i*w/22,y=h-9+(i%3)*3;ellipse(x,y,10,8,i%2?'#529e6c':'#84c559');}
      // Edge flowers: no visually noisy detail in the catch zone.
      [w*.06,w*.12,w*.92,w*.96].forEach((x,i)=>{const y=h-28+(i%2)*7;for(let j=0;j<5;j++){const a=j*Math.PI*2/5;ellipse(x+Math.cos(a)*4,y+Math.sin(a)*4,3,3,i%2?'#fff6d7':'#ffacd3');}ellipse(x,y,2,2,'#e9af2c');});
      if(w>820){
        c.save();c.translate(w*.093,h-47);c.rotate(-.09);c.fillStyle='#ab7c65';c.fillRect(-22,-12,7,34);c.fillRect(19,-12,7,34);c.fillStyle='#efc590';c.strokeStyle='#aa7459';c.lineWidth=3;c.beginPath();c.roundRect(-50,-59,100,55,7);c.fill();c.stroke();c.fillStyle='#59405b';c.font='900 13px Trebuchet MS, sans-serif';c.textAlign='center';c.fillText('TINY',0,-36);c.fillText('TERRORS',0,-20);c.restore();
      }
    }
    _drawItem(item) {
      const c=this.ctx,img=this.icons[item.type];
      if(!img)return;
      c.save();c.translate(item.x,item.y);
      if(!this.reducedMotion){c.strokeStyle='#ffffff91';c.lineWidth=2;c.beginPath();c.moveTo(-item.size*.2,-item.size*.62);c.lineTo(-item.size*.2,-item.size);c.moveTo(item.size*.15,-item.size*.63);c.lineTo(item.size*.15,-item.size*1.18);c.stroke();}
      c.rotate(item.rotation||0);
      const scale=item.size/Math.max(img.width,img.height),iw=img.width*scale,ih=img.height*scale;
      c.drawImage(img,-iw/2,-ih/2,iw,ih);c.restore();
    }
    draw() {
      if(!this.ctx||!this.scenery)return;
      const c=this.ctx,w=this.W,h=this.H;
      c.setTransform(this.dpr,0,0,this.dpr,0,0);c.clearRect(0,0,w,h);c.drawImage(this.scenery,0,0,w,h);
      if(this.state==='ready'||this.state==='loading'){
        const demo=[['star',.18,.16],['coin',.34,.33],['candy',.49,.13],['heart',.66,.26],['burger',.82,.15],['bomb',.77,.51],['slime',.24,.53]];
        demo.forEach(([type,x,y],i)=>this._drawItem({type,x:x*w,y:y*h,size:this.itemSize*(w>600?1.24:1.05),rotation:i%2?.1:-.08}));
      } else this.items.forEach(item=>this._drawItem(item));
      const char=this.characters[this.selected];
      c.save();
      c.fillStyle='#33703d43';c.beginPath();c.ellipse(this.playerX,this.ground+2,this.playerH*.30,7,0,0,Math.PI*2);c.fill();
      if(this.slow>0){c.fillStyle='#9bdc5ec7';c.beginPath();c.ellipse(this.playerX,this.ground+1,this.playerW*.65,7,0,0,Math.PI*2);c.fill();}
      c.translate(this.playerX,this.ground);c.rotate(this.lean);
      const squash=this.reducedMotion?0:Math.sin(this.bounce*10)*.025;
      c.scale(1+squash,1-squash);
      if(char.image){const ph=this.playerH,pw=ph*char.image.width/char.image.height;c.drawImage(char.image,-pw/2,-ph,pw,ph);}
      else {c.fillStyle='#ff3499';c.strokeStyle='#ffffff';c.lineWidth=4;c.beginPath();c.roundRect(-this.playerW/2,-this.playerH*.72,this.playerW,this.playerH*.65,17);c.fill();c.stroke();c.fillStyle='white';c.font='900 30px sans-serif';c.textAlign='center';c.fillText((char.name||'?').charAt(0),0,-this.playerH*.3);}
      c.restore();
      if(this.shield>0 && this.state!=='over') {c.save();c.strokeStyle='#fff9c4';c.lineWidth=3;c.globalAlpha=.65;c.beginPath();c.ellipse(this.playerX,this.ground-this.playerH*.5,this.playerH*.43,this.playerH*.56,0,0,Math.PI*2);c.stroke();c.restore();}
      for(const p of this.particles){c.globalAlpha=clamp(p.life*2,0,1);c.fillStyle=p.color;c.beginPath();c.arc(p.x,p.y,p.size,0,Math.PI*2);c.fill();}c.globalAlpha=1;
      for(const p of this.popups){c.save();c.globalAlpha=clamp(p.life*2,0,1);c.textAlign='center';c.font=`900 ${w<500?16:21}px Trebuchet MS, sans-serif`;c.lineWidth=4;c.strokeStyle='#fffdf4';const x=clamp(p.x,45,w-45);c.strokeText(p.text,x,p.y);c.fillStyle=p.color;c.fillText(p.text,x,p.y);c.restore();}
    }
  }
  customElements.define('tt-chaos-catch', ChaosCatch);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('tt-chaos-catch')) event.target.connectedCallback();
    event.target.querySelectorAll?.('tt-chaos-catch').forEach(game => game.connectedCallback());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
